import StorageUtil from "@/utils/StorageUtil";

let router_util_vue_router = null;

function RouterUtil() {

    const _this = this;

    const _storage_key = "_router_util_vue_router_data";

    this.back = function (index, vm) {
        if (_this.hasRouter(vm)) {
            if (index) {
                _this.go('/index', true, vm);
            } else {
                try {
                    const router_data = StorageUtil.getObject();
                    if (router_data && router_data.back) {
                        StorageUtil.removeObjectAttr(_storage_key, "back");
                        _this.go(router_data.back);
                    } else if (router_data && router_data.replaceCount) {
                        const replaceCount = router_data.replaceCount;
                        StorageUtil.removeObjectAttr(_storage_key, "replaceCount");
                        _this.getRouter(vm).go(0 - replaceCount);
                    } else {
                        _this.getRouter(vm).back();
                    }
                } catch (e) {
                    _this.go('/index', true, vm);
                }
            }
        }
    };

    this.home = function (replace, vm) {
        this.go('/index', !replace, vm);
    };

    this.go = function (path, replace, back, vm) {
        if (_this.hasRouter(vm)) {
            if (back) {
                StorageUtil.setObjectAttr(_storage_key, "back", back);
            }
            if (replace) {
                StorageUtil.setObjectAttr(_storage_key, "replace", replace);
                let replaceCount = StorageUtil.getObjectAttr(_storage_key, "replaceCount");
                if (replaceCount && replaceCount > 0) {
                    StorageUtil.setObjectAttr(_storage_key, "replaceCount", replaceCount++);
                } else {
                    StorageUtil.setObjectAttr(_storage_key, "replaceCount", 1);
                }
                _this.getRouter(vm).replace(path);
            } else {
                _this.getRouter(vm).push(path);
            }
        }
    };

    this.getQueryValue = function (route, queryName) {
        if (route.query) {
            return route[queryName];
        }
        return null;
    }

    this.containsQuery = function (route, queryName) {
        if (route.query) {
            return route.query.hasOwnProperty(queryName);
        }
        return false;
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    this.setRouter = function (router) {
        router_util_vue_router = router;
        // if (!StorageUtil.contains(_storage_key)) {
        //     StorageUtil.setObject(_storage_key, {});
        // }
    };

    this.getRouter = function (vm) {
        if (vm) {
            return vm.$router;
        } else {
            return router_util_vue_router;
        }
    };

    this.hasRouter = function (vm) {
        return !!_this.getRouter(vm);
    };
}

export default new RouterUtil();
